//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      hover: false,
    };
  },
  props: {
    icon: {
      required: true,
    },
    title: {
      required: true,
    },
    description: {
      required: true,
    },
    cta: {
      required: false,
      default: "Create Document",
    },
    link: {
      required: true,
    },
  },
};
